<template>
  <transition name="analysis">
    <div class="analysis">
      <iframe allowtransparency="true" :src="analysisUrl"></iframe>
    </div>
  </transition>
</template>
<script>
import common from "common";
import { mapState } from "vuex";
export default {
  name: "analysis",
  data() {
    return {
      analysisUrl: "",
      interval: null,
    };
  },
  computed: {
    ...mapState(["lesson_id", "course_id", "COOK"]),
  },
  props: {
    progressArr: {
      type: Array,
      default: () => {
        return [];
      },
    },
    currentIndex: {
      type: Number,
    },
  },
  created() {
    this.init();
    window.addEventListener("message", this.iframeMessage, false);
  },
  methods: {
    init() {
      this.analysisUrl = this.createSrc();
      this.$parent.loadingShow = true;
      this.interval = setTimeout(() => {
        this.$emit("analysisLoadErr");
        this.$parent.loadingShow = false;
      }, 10 * 1000);
    },
    createSrc() {
      const env = common.get("configurl") || common.configurl;
      const qid = this.progressArr[this.currentIndex - 1].id;
      let strurl = `${common.API["800002"]}answerparse/index.html?`;
      let urldata = {
        from: "h5",
        device:common.device,
        lessonId: this.lesson_id,
        cook: this.COOK,
        courseId:this.course_id,
        networkEnvironment:env.name,
        app_ver:common.version,
        t:Date.now(),
        qid: qid 
      };
      for (let item in urldata) {
        strurl += item + "=" + urldata[item] + "&";
      }
      return strurl.slice(0, -1);
    },
    loadAgain() {
      this.analysisUrl = "";
      setTimeout(() => {
        this.init();
      }, 500);
    },
    iframeMessage(rs) {
      if (rs.data.ctype == "52") {
        clearTimeout(this.interval);
        this.$parent.loadingShow = false;
      }
      if (rs.data.ctype == "54") {
        this.$parent.isJiexi = rs.data.custom_data.show?2:3
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("message", this.iframeMessage, false);
    clearTimeout(this.interval);
    this.$parent.loadingShow = false;
  },
};
</script>
<style lang="less" scoped rel="stylesheet/less">
.analysis {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 90;
  background: #c9efff;
  iframe {
    width: 100%;
    height: 100%;
    max-width: 1100px;
    border: none;
  }
}
.analysis-enter-active {
  animation: slideTop 0.6s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.analysis-leave-active {
  animation: slideTop 0.6s reverse cubic-bezier(0.645, 0.045, 0.355, 1);
}
</style>


// WEBPACK FOOTER //
// src/components/bussiness/homework/analysis.vue